import { Injectable, signal } from '@angular/core';

export interface ConfirmOptions {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
}

interface ConfirmRequest extends ConfirmOptions {
  resolve: (confirmed: boolean) => void;
}

/** App-wide yes/no question; `<ui-confirm-dialog>` in the app shell shows it. */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private readonly current = signal<ConfirmRequest | null>(null);

  /** What the dialog renders; null when nothing is being asked. */
  readonly request = this.current.asReadonly();

  /** Resolves true on confirm, false on cancel, close or Esc. */
  ask(options: ConfirmOptions): Promise<boolean> {
    // A new question replaces one left unanswered.
    this.current()?.resolve(false);
    return new Promise((resolve) => this.current.set({ ...options, resolve }));
  }

  answer(confirmed: boolean): void {
    const request = this.current();
    this.current.set(null);
    request?.resolve(confirmed);
  }
}
